import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AttachmentData,
  Attachments,
} from '@app/model/payment-request/payment-request.dto';
import { BehaviorSubject, Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SERVER_BASE_URL } from 'src/environments/environment';
import * as Sentry from '@sentry/angular';
import { LoggingService } from '../logging-service/logging.service';
import { QueryParamsService } from '../query-params/query-params.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentRequestService {
  attachmentData$: BehaviorSubject<AttachmentData[]> = new BehaviorSubject<
    AttachmentData[]
  >([]);

  constructor(
    private http: HttpClient,
    private loggingService: LoggingService,
    private queryParamsService: QueryParamsService
  ) {}

  fetchAttachmentsByPaymentRequest(
    paymentRequest: any
  ): Observable<AttachmentData[]> {
    const attachmentRequests = paymentRequest?.attachments?.map(
      (attachment: Attachments) =>
        this.http.get<AttachmentData>(
          `${SERVER_BASE_URL}/request/attachment/${attachment.id}`,
          { withCredentials: true }
        )
    );

    return forkJoin(attachmentRequests).pipe(
      map((responses: AttachmentData[]) => {
        const attachmentData = [...responses];
        this.attachmentData$.next(attachmentData);
        return attachmentData;
      }),
      catchError((err) => {
        let id = this.queryParamsService.getQueryParams().id;

        Sentry.captureException(err);
        this.loggingService.reportCrash(
          'error fetching payment request attachments',
          'message: ' + err.message + '. prid: ' + id
        );
        return of([]);
      })
    );
  }

  getAttachmentData(): Observable<AttachmentData[]> {
    return this.attachmentData$.asObservable();
  }

  cancelPaymentRequest() {
    return this.http
      .post<any>(`${SERVER_BASE_URL}/request/cancel/`, {
        withCredentials: true,
      })
      .toPromise();
  }
}
